import React from 'react'
import ResultsSection from './ResultsSection'
import useCareerExploration from './CareerExplorationProvider'
import useTranslation from '../shared/TranslationProvider'
import parse from 'html-react-parser'

const ResponsibilitiesSection = ({ career, ...props }) => {
  const { keyResponsibilities } = useCareerExploration()
  const responsibilities = keyResponsibilities(career)
  return (
    <ResultsSection career={career} section="responsibilities" {...props}>
      <ResponsibilitiesSectionInner responsibilities={responsibilities} />
    </ResultsSection>
  )
}

const ResponsibilitiesSectionInner = ({ responsibilities }) => {
  const { t } = useTranslation('Page')
  if (!responsibilities) return <div>{t('not_available')}</div>
  return (
    <div className="prose-ul:list-disc prose-ul:pl-6">
      {parse(responsibilities)}
    </div>
  )
}

export default ResponsibilitiesSection
